import React from 'react';

import useIsMobile from '../hooks/useIsMobile';

import styles from './popupv2.scss';

const PopupV2 = (props) => {
    const { config = {}, onCloseClick, 'data-testid': dataTestId } = props;
    const {
        size,
        gradient, // bool
        scrollable, // bool
        customHeader, // fn => jsx
        customWidth,
        bodyClassName, // string - additional class for modal body
    } = config;

    const { isMobileWidth } = useIsMobile();
    const style = !isMobileWidth && customWidth ? { maxWidth: customWidth } : {};

    return (
        <div className={`${styles.modal}`} tabIndex="-1" data-testid={dataTestId || undefined}>
            <div className={`${styles.modalDialog} ${styles.centered} ${scrollable ? styles.scrollable : ''} ${styles[size]} ${gradient ? styles.gradient : ''}`} style={style}>
                <div className={styles.modalContent}>
                    {!customHeader && (
                        <div className={styles.modalHeader}>
                            <div className={styles.btnClose} onClick={onCloseClick} data-testid={dataTestId && `${dataTestId}.close-btn`}>
                                <i className={`utr utr-close`} />
                            </div>
                        </div>
                    )}
                    {customHeader?.()}
                    <div className={`${styles.modalBody} ${bodyClassName || ''}`} data-testid={dataTestId && `${dataTestId}.body`}>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopupV2;
